export async function waitForAnimations(element) {
  return Promise.allSettled(element.getAnimations().map(animation => animation.finished))
}
